import React, { useState, useEffect, useMemo } from "react";
import { useSpring, animated } from "react-spring";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAws,
  faGoogle,
  faMicrosoft,
  faNodeJs,
  faFigma,
  faPython,
  faAngular,
  faReact,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { BiBot } from "react-icons/bi";
import {
  SiDigitalocean,
  SiDotnet,
  SiGooglecloud,
  SiIbmcloud,
  SiOpenai,
  SiOracle,
  SiSpringboot,
} from "react-icons/si";

import "./About.css";
import { Link } from "react-router-dom";
// import img1 from "../../images/about1.jpg";
// import img2 from "../../images/about2.jpg";
// import img3 from "../../images/about3.jpg";
// import img4 from "../../images/about4.jpg";
// import img5 from "../../images/about5.jpg";
import img1 from "../../images/img1.jpeg";
import img2 from "../../images/img2.jpeg";
import img3 from "../../images/img3.jpg";
// import img4 from "../../images/img4.jpg";
import team5 from "../../images/aazira-img1.jpeg";
import team6 from "../../images/aazira-img2.jpeg";
import team7 from "../../images/aazira-img3.jpeg";
import { FaCss3, FaHtml5, FaJava } from "react-icons/fa";

export default function About() {
  // simple fade-in for hero copy
  const fadeIn = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 300,
  });

  const [activeTab, setActiveTab] = useState("cloudServices");

  const tabs = useMemo(
    () => [
      "cloudServices",
      "frameworks",
      "aiTools",
      "uiux",
      "programmingLanguages",
    ],
    []
  );

  // icon data: each tab has array of {id, node}
  const iconData = useMemo(
    () => ({
      cloudServices: [
        { id: "aws", node: <FontAwesomeIcon icon={faAws} /> },
        { id: "gcp", node: <SiGooglecloud /> },
        { id: "ms", node: <FontAwesomeIcon icon={faMicrosoft} /> },
        { id: "ibm", node: <SiIbmcloud /> },
        { id: "oracle", node: <SiOracle /> },
        { id: "digitalocean", node: <SiDigitalocean /> },
      ],
      frameworks: [
        { id: "react", node: <FontAwesomeIcon icon={faReact} /> },
        { id: "node", node: <FontAwesomeIcon icon={faNodeJs} /> },
        { id: "angular", node: <FontAwesomeIcon icon={faAngular} /> },
        { id: "dotnet", node: <SiDotnet /> },
        { id: "springboot", node: <SiSpringboot /> }, // Java Spring Boot
        { id: "html", node: <FaHtml5 /> }, // HTML
        { id: "css", node: <FaCss3 /> }, // CSS
      ],
      aiTools: [
        { id: "openai", node: <SiOpenai /> },
        { id: "bot", node: <BiBot /> },
        { id: "github", node: <FontAwesomeIcon icon={faGithub} /> },
        { id: "google", node: <FontAwesomeIcon icon={faGoogle} /> },
      ],
      uiux: [
        { id: "figma", node: <FontAwesomeIcon icon={faFigma} /> },
        { id: "ms", node: <FontAwesomeIcon icon={faMicrosoft} /> },
        { id: "reactui", node: <FontAwesomeIcon icon={faReact} /> },
      ],
      programmingLanguages: [
        { id: "js", node: <FontAwesomeIcon icon={faNodeJs} /> },
        { id: "py", node: <FontAwesomeIcon icon={faPython} /> },
        { id: "java", node: <FaJava /> },
        { id: "react", node: <FontAwesomeIcon icon={faReact} /> },
        { id: "node", node: <FontAwesomeIcon icon={faNodeJs} /> },
        { id: "angular", node: <FontAwesomeIcon icon={faAngular} /> },
        { id: "dotnet", node: <SiDotnet /> },
        { id: "springboot", node: <SiSpringboot /> }, // Java Spring Boot
        { id: "html", node: <FaHtml5 /> }, // HTML
        { id: "css", node: <FaCss3 /> }, // CSS
      ],
    }),
    []
  );

  // Auto-switch tabs every 3 seconds
  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentIndex = tabs.indexOf(activeTab);
      const nextTab = tabs[(currentIndex + 1) % tabs.length];
      setActiveTab(nextTab);
    }, 8000);

    return () => clearInterval(intervalId);
  }, [activeTab, tabs]);

  return (
    <section className="about-us">
      {/* HERO / INTRO */}
      <div className="container about-hero-layout">
        <animated.div style={fadeIn} className="about-hero-left">
          <div className="about-hero-pill">ABOUT Aazira Solutions</div>
          <h2 className="about-hero-title">
            We don&apos;t just ship code, we ship outcomes.
          </h2>
          <p className="about-hero-subtext about-subtext">
            We are a passionate team of engineers, designers, and product
            thinkers building high-performance software solutions for ambitious
            businesses worldwide.
          </p>

          <ul className="about-hero-points">
            <li>✔ Product engineering from idea to launch</li>
            <li>✔ Deep expertise in ERP, cloud, AI & mobile</li>
            <li>✔ Long-term partners, not just vendors</li>
          </ul>
        </animated.div>

        <div className="about-hero-right">
          <div className="about-metric-card">
            <span className="metric-label">Projects Delivered</span>
            <span className="metric-value">55+</span>
            <p className="metric-caption">
              End-to-end digital products shipped across multiple domains.
            </p>
          </div>
          <div className="about-metric-card">
            <span className="metric-label">Industries Served</span>
            <span className="metric-value">20+</span>
            <p className="metric-caption">
              From retail & manufacturing to education, logistics & finance.
            </p>
          </div>
          <div className="about-metric-card">
            <span className="metric-label">Client Satisfaction</span>
            <span className="metric-value">100%</span>
            <p className="metric-caption">
              Long-term relationships built on trust, quality and delivery.
            </p>
          </div>
        </div>
      </div>

      {/* CORE VALUE HIGHLIGHTS (3 CARDS) */}
      <div className="container about-values-block">
        <div className="values-grid">
          <animated.div
            style={useSpring({
              opacity: 1,
              from: { opacity: 0, transform: "translateY(20px)" },
              delay: 500,
            })}
            className="value-card"
          >
            <h3>Innovation</h3>
            <p className="text-gray-400">
              We thrive on experimentation and constantly explore modern
              architectures, tools, and ways of building.
            </p>
          </animated.div>

          <animated.div
            style={useSpring({
              opacity: 1,
              from: { opacity: 0, transform: "translateY(20px)" },
              delay: 650,
            })}
            className="value-card"
          >
            <h3>Excellence</h3>
            <p className="text-gray-400">
              From code quality to UX, we obsess over the details that make a
              product feel premium.
            </p>
          </animated.div>

          <animated.div
            style={useSpring({
              opacity: 1,
              from: { opacity: 0, transform: "translateY(20px)" },
              delay: 800,
            })}
            className="value-card"
          >
            <h3>Collaboration</h3>
            <p className="text-gray-400">
              We work as an extended team with our clients – transparent, agile
              and goal-driven.
            </p>
          </animated.div>
        </div>
      </div>

      {/* ===========================
      IMAGE SHOWCASE WITH TITLE
=========================== */}
      <div className="image-section-wrapper">
        <h2 className="image-section-title">Our Team</h2>

        <div className="image-card-grid">
          <div className="image-card">
            <img src={img1} alt="Image 1" className="image-card-img" />
          </div>

          <div className="image-card">
            <img src={img2} alt="Image 2" className="image-card-img" />
          </div>
          <div className="image-card">
            <img src={img3} alt="Image 3" className="image-card-img" />
          </div>
        </div>

        <div className="image-card-grid">

          <div className="image-card">
            <img src={team6} alt="Image 2" className="image-card-img" />
          </div>

          <div className="image-card">
            <img src={team5} alt="Image 1" className="image-card-img" />
          </div>

          <div className="image-card">
            <img src={team7} alt="Image 3" className="image-card-img" />
          </div>

        </div>
      </div>

      {/* PARTNER ECOSYSTEM / TECH STACK TABS */}
      <div className="app-container">
        <header className="text-center">
          <h2 className="partner-title">Our Partner Ecosystem & Tech Stack</h2>
          <p className="about-subtext partner-subtext">
            A carefully curated set of cloud platforms, frameworks and AI tools
            that help us build reliable, scalable and future-ready products.
          </p>
        </header>

        <nav className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? "tab-active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.replace(/([A-Z])/g, " $1").toUpperCase()}
            </button>
          ))}
        </nav>

        <div className="tab-content">
          {iconData[activeTab]?.map(({ id, node }) => (
            <div key={id} className="tech-icon-shell">
              {node}
            </div>
          ))}
        </div>
      </div>

      {/* CORE VALUES (GRID) */}
      <div className="core-values-container">
        <div className="core-values-header">
          <h1>Our Core Values</h1>
          <p className="about-subtext">
            Our core values guide every decision, every line of code, and every
            interaction with our clients and partners.
          </p>
        </div>
        <div className="core-values-grid">
          <div className="core-value-card">
            <h2>Integrity</h2>
            <p className="about-subtext">
              We uphold the highest standards of honesty, transparency and
              ownership in all our actions.
            </p>
          </div>
          <div className="core-value-card">
            <h2>Customer-Centricity</h2>
            <p className="about-subtext">
              We align our success with yours, focusing on measurable business
              outcomes, not just deliverables.
            </p>
          </div>
          <div className="core-value-card">
            <h2>Innovation</h2>
            <p className="about-subtext">
              We constantly innovate to provide futuristic solutions that meet
              evolving business needs.
            </p>
          </div>
          <div className="core-value-card">
            <h2>Collaboration</h2>
            <p className="about-subtext">
              We collaborate closely with stakeholders to design solutions that
              actually fit your reality.
            </p>
          </div>
          <div className="core-value-card">
            <h2>Excellence</h2>
            <p className="about-subtext">
              We strive for excellence in every project – architecture,
              performance, security and UX.
            </p>
          </div>
        </div>
      </div>

      {/* VISION & MISSION */}
      <h2 className="section-title">Vision &amp; Mission</h2>
      <div className="vision-mission-container">
        <div className="vision-mission-content">
          <div className="vision">
            <h3>Vision</h3>
            <p className="about-subtext">
              To be a trusted technology partner for businesses worldwide,
              delivering solutions that are as robust as they are delightful to
              use.
            </p>
          </div>
          <div className="mission">
            <h3>Mission</h3>
            <p className="about-subtext">
              To design, build and maintain custom IT solutions that drive
              efficiency, innovation and sustainable growth for our clients.
            </p>
          </div>
        </div>
      </div>

      {/* FINAL CTA STRIP */}
      <div className="about-cta-strip">
        <div className="about-cta-inner">
          <h2>Ready to build your next product with us?</h2>
          <p>
            Share your idea or challenge, and we&apos;ll help you shape it into
            a roadmap, prototype and production-ready solution.
          </p>
        </div>
        {/* <button className="about-cta-button">Book a Discovery Call</button> */}
        <Link to="/contact">
          <button className="about-cta-button">Book a Discovery Call</button>
        </Link>
      </div>
    </section>
  );
}
